(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3b99"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3b99"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lGKbD", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $fca158e7bc793dc7$export$6503ec6e8aabbaf; }, function (v) { return $fca158e7bc793dc7$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $fca158e7bc793dc7$export$f7ad0328861e2f03; }, function (v) { return $fca158e7bc793dc7$export$f7ad0328861e2f03 = v; });
var $fca158e7bc793dc7$export$6503ec6e8aabbaf;
var $fca158e7bc793dc7$export$f7ad0328861e2f03;
"use strict";
var $fca158e7bc793dc7$var$mapping = new Map();
function $fca158e7bc793dc7$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$fca158e7bc793dc7$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $fca158e7bc793dc7$var$resolve(id) {
    var resolved = $fca158e7bc793dc7$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$fca158e7bc793dc7$export$6503ec6e8aabbaf = $fca158e7bc793dc7$var$register;
$fca158e7bc793dc7$export$f7ad0328861e2f03 = $fca158e7bc793dc7$var$resolve;

});

parcelRegister("17QCl", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $0d1f42a1cefd465e$export$bdfd709ae4826697; }, function (v) { return $0d1f42a1cefd465e$export$bdfd709ae4826697 = v; });
var $0d1f42a1cefd465e$export$bdfd709ae4826697;
var $0d1f42a1cefd465e$export$c9e73fbda7da57b6;
var $0d1f42a1cefd465e$export$5a759dc7a1cfb72a;
"use strict";
var $0d1f42a1cefd465e$var$bundleURL = {};
function $0d1f42a1cefd465e$var$getBundleURLCached(id) {
    var value = $0d1f42a1cefd465e$var$bundleURL[id];
    if (!value) {
        value = $0d1f42a1cefd465e$var$getBundleURL();
        $0d1f42a1cefd465e$var$bundleURL[id] = value;
    }
    return value;
}
function $0d1f42a1cefd465e$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $0d1f42a1cefd465e$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $0d1f42a1cefd465e$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $0d1f42a1cefd465e$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$0d1f42a1cefd465e$export$bdfd709ae4826697 = $0d1f42a1cefd465e$var$getBundleURLCached;
$0d1f42a1cefd465e$export$c9e73fbda7da57b6 = $0d1f42a1cefd465e$var$getBaseURL;
$0d1f42a1cefd465e$export$5a759dc7a1cfb72a = $0d1f42a1cefd465e$var$getOrigin;

});

var $b75ff5eb831a9aa3$exports = {};


(parcelRequire("lGKbD")).register((parcelRequire("17QCl")).getBundleURL("gLX7v"), JSON.parse('["gLX7v","authorize.9aaaa40c.js","jD60Z","web-vitals.cddab53c.js"]'));

})();
//# sourceMappingURL=authorize.runtime.94c5a0d5.js.map
